import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";
import {
  GET_TERM,
  DELETE_TERM
} from "../actions";

import {
  getTermSuccess,
  getTermError,
  trashTermSuccess,
  trashTermError
} from "./actions";

export function* watchGetTerm() {
  yield takeEvery(GET_TERM, getTerm);
}

export function* watchTrashTerm() {
  yield takeEvery(DELETE_TERM, trashTerm);
}

const getTermAsync = async (payload) => {
  try {
    const recordTermsReturned = await centralApiAxios.get(
      "terms/" + payload.termId, getActivityHeadersUpdated(payload)
    );
    if (recordTermsReturned.data) {
      return {
        term: recordTermsReturned.data,
        message: null,
      };
    }
    return { message: "Get terms failed." };
  } catch (error) {
    return {
      message: "Failed to get terms. ",
    };
  }
};

function* getTerm({ payload }) {

  try {
    const returnedData = yield call(getTermAsync, payload);
    if (!returnedData.message) {
      yield put(
        getTermSuccess({
          term: returnedData.term,
        })
      );
    } else {
      yield put(getTermError(returnedData.message));
    }
  } catch (error) {
    yield put(getTermError(error));
  }
}

const trashTermAsync = async (payload) => {
  try {
    const recordTermReturned = await centralApiAxios.delete(
      "terms?id=" + payload.termId + "&trash=true", getActivityHeadersUpdated(payload)
    );
    if (recordTermReturned.data) {
      return {
        successMessage: "Trash Term was successful.",
        message: null,
      };
    }
    return { message: "Trash Term failed." };
  } catch (error) {
    console.log(error);
    return {
      message: "Trash Term failed.",
    };
  }
};

function* trashTerm({ payload }) {
  try {
    const returnedData = yield call(trashTermAsync, payload);
    if (!returnedData.message) {
      yield put(trashTermSuccess(returnedData.successMessage));
    } else {
      yield put(trashTermError(returnedData.message));
    }
  } catch (error) {
    yield put(trashTermError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetTerm),
    fork(watchTrashTerm)
  ]);
}
